import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAFAF9] flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <XCircle className="h-16 w-16 text-[#EA580C] mx-auto mb-6" />
        <h1 className="font-manrope font-bold text-3xl text-[#0F2A44] mb-2">
          Payment Cancelled
        </h1>
        <p className="font-public text-[#4B5563] mb-8">
          Your payment was cancelled. You can try again anytime.
        </p>
        <div className="flex gap-4 justify-center">
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="rounded-lg"
          >
            Return Home
          </Button>
          <Button
            onClick={() => navigate(-1)}
            className="bg-[#0F2A44] hover:bg-[#0F2A44]/90 text-white rounded-lg"
          >
            Try Again
          </Button>
        </div>
      </div>
    </div>
  );
}